require('core-js');require('regenerator-runtime/runtime');import $ from 'jquery';
import 'whatwg-fetch';
window.jQuery = $;
window.$ = $;

// FOUNDATION
require('../../../wdh-foundation/dgs/dgs-api.js');
require('../../../wdh-foundation/dgs/dgs-events.js');

// FEATURE
require('../../bernafon/js/feature/component-intro-banner');
require('../../bernafon/js/feature/component-text-image-spot');
require('../../bernafon/js/feature/component-option-spot');
require('../../bernafon/js/feature/custom-component-image-spot');
require('./feature/wdh-remotecare-admin-panel');

// // PROJECT
require('./project/header');
require('@demant/wdh-gdpr/lib/default.implementation.js');